










import AppLayout from '@tool/Layouts/AppLayout.vue'
import UpdatePasswordForm from '@tool/Pages/App/Settings/Profile/Forms/UpdatePasswordForm.vue'
import UpdateProfileInfoForm from '@tool/Pages/App/Settings/Profile/Forms/UpdateProfileInfoForm.vue'
import Breadcrumbs from "@tool/Components/Breadcrumbs.vue";
import {PropType} from "vue";

export default {
    props: {
        user: {
            type: Object as PropType<{
                name: string;
                email: string
            }>,
            required: true
        }
    },

    components: {
        Breadcrumbs,
        AppLayout,
        UpdatePasswordForm,
        UpdateProfileInfoForm,
    },
}
